module.exports = __webpack_public_path__ + "img/Mailbaum_2019.fb2f916e.jpg";